import { filterKeys, promoteKey } from "web/services/helpers"

import ExpressionEngine from "web/services/expressions"

// Returns value blob for the fields requested from a
// TLOs values object which includes additional field values
export function getValueForFields(values, fields) {
  return promoteKey(
    filterKeys(
      values,
      fields.map((f) => f.key)
    ),
    "value"
  )
}

export function calculateShown(field, values) {
  const { show_expression } = field

  if (
    show_expression === undefined ||
    show_expression === null ||
    show_expression === ""
  ) {
    return true
  }

  return ExpressionEngine.evaluate(show_expression, values, field.namespace)
}
